import { Directive, Inject, Input } from '@angular/core';
import { RouterService } from '../../services';
import { ActivatedRoute } from '@angular/router';
import { IEnvironment, WhitelabelImage, WhitelabelImageType } from '../../models';
import { Store } from '@ngrx/store';
import * as fromRegistrationStore from '../../../shared';

@Directive()
export abstract class ConfirmationEmailInfoBaseComponent {
  @Input() imagePath? = '~/assets/shared/images/register-success.png';
  public whitelabelImage = WhitelabelImage;
  public whitelabelImageType = WhitelabelImageType;

  constructor(
    @Inject('ENVIRONMENT') private environment: IEnvironment,
    private router: RouterService,
    private activeRoute: ActivatedRoute,
    private registerStore: Store<fromRegistrationStore.RegistrationState>
  ) {}

  goToLogin(): void {
    this.router.navigate(['../'], { relativeTo: this.activeRoute });
    this.registerStore.dispatch(fromRegistrationStore.ClearRegistrationFormState());
  }
}
